<template>
  <div>
    <Head title=" Deleivery Run Orders" />
    <h1 class="mb-8 text-3xl font-bold">
      <Link
        class="text-orange-400 hover:text-orange-600"
        :href="`/dispatches/delivery-runs`"
        >Delivery Runs</Link
      >
      <span class="text-orange-400 font-medium">/</span>{{ delivery_run.number }}/{{
        user.name
      }}/Orders
    </h1>
    <div v-show="false" class="flex items-center justify-between mb-6">
      <search-filter
        v-model="search.search"
        class="mr-4 w-full max-w-md"
        @reset="reset"
      />
      <a
        v-if="orders.data.length > 0"
        class="btn-orange px-3 py-2 text-xs cursor-pointer"
        :href="`/dispatches/delivery-runs/${delivery_run.id}/download`"
        download
        target="__blank"
      >
        <span>Download</span>
      </a>
    </div>
    <div class="bg-white rounded-md shadow overflow-x-auto">
      <table class="w-full whitespace-nowrap">
        <tr class="text-left font-bold">
          <th class="pb-3 pt-3 px-3">Date</th>
          <th class="pb-3 pt-3 px-3">Date Picked</th>
          <th class="pb-3 pt-3 px-3">Order Number</th>
          <th class="pb-3 pt-3 px-3">Customer</th>
          <th class="pb-3 pt-3 px-3">Contact</th>
          <th class="pb-3 pt-3 px-3">Physical Address</th>
          <th class="pb-3 pt-3 px-3">Quantity</th>
          <th class="pb-3 pt-3 px-3">Amount</th>
          <th class="pb-3 pt-3 px-3">Volume</th>
          <th class="pb-3 pt-3 px-3">Status</th>
          <th class="pb-3 pt-3 px-3 text-end"></th>
        </tr>
        <tr
          v-for="list in orders.data"
          :key="list.id"
          class="hover:bg-orange-100 focus-within:bg-gray-100"
        >
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${list.delivery_run_id}/orders/${list.order_id}/skus`"
              title=""
            >
              {{ list.date }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${list.delivery_run_id}/orders/${list.order_id}/skus`"
              title=""
            >
              {{ list.date_closed }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${list.delivery_run_id}/orders/${list.order_id}/skus`"
              title=""
            >
              {{ list.order_no }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${list.delivery_run_id}/orders/${list.order_id}/skus`"
              title=""
            >
              {{ list.name }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${list.delivery_run_id}/orders/${list.order_id}/skus`"
              title=""
            >
              {{ list.contact }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${list.delivery_run_id}/orders/${list.order_id}/skus`"
              title=""
            >
              {{ list.physical_address }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${list.delivery_run_id}/orders/${list.order_id}/skus`"
              title=""
            >
              {{ list.quantity }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${list.delivery_run_id}/orders/${list.order_id}/skus`"
              title=""
            >
              {{ list.amount }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${list.delivery_run_id}/orders/${list.order_id}/skus`"
              title=""
            >
              {{ list.volume }}
            </Link>
          </td>
          <td class="border-t">
            <Link
              class="flex items-center px-3 py-3 focus:text-orange-500"
              :href="`/dispatches/delivery-runs/${delivery_run.id}/orders/${list.order_id}/packed/skus`"
              title=""
            >
              {{ list.status }}
            </Link>
          </td>
          <td class="w-px border-t">
            <a
              :href="`/dispatches/delivery-runs/${list.delivery_run_id}/orders/${list.order_id}/skus`"
              class="flex items-center justify-end pr-3"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="w-6 h-6"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M8.25 4.5l7.5 7.5-7.5 7.5"
                />
              </svg>
            </a>
          </td>
        </tr>
        <tr v-if="orders.data.length === 0">
          <td class="px-3 py-3 border-t" colspan="5">No data found</td>
        </tr>
      </table>
    </div>
    <pagination class="mt-6" :links="orders.links" />
  </div>
</template>

<script>
import { Head, Link } from "@inertiajs/inertia-vue3";
import pickBy from "lodash/pickBy";
import Layout from "@/Shared/Layout";
import throttle from "lodash/throttle";
import mapValues from "lodash/mapValues";
import SearchFilter from "@/Shared/SearchFilter";
import Pagination from "@/Shared/Pagination";

export default {
  components: {
    Head,
    Link,
    SearchFilter,
    Pagination,
  },
  layout: Layout,
  props: {
    filters: Object,
    user: Object,
    orders: Object,
    delivery_run: Object,
  },
  data() {
    return {
      search: {
        search: this.filters.search,
      },
    };
  },
  watch: {
    search: {
      deep: true,
      handler: throttle(function () {
        this.$inertia.get(
          `/dispatches/delivery-runs/${this.delivery_run.id}/orders`,
          pickBy(this.search),
          { preserveState: true }
        );
      }, 150),
    },
  },
  methods: {
    reset() {
      this.search = mapValues(this.search, () => null);
    },
  },
};
</script>
